import React from 'react';
import PropTypes from 'prop-types';

import {Field, reduxForm} from 'redux-form';
import Button from '../button/Button';
import FieldText from '../fields/fieldText/FieldText';
import {FormattedMessage, injectIntl} from 'react-intl';

@injectIntl
@reduxForm({
  form: 'recoverPassword'
})
export default class RecoverPasswordForm extends React.PureComponent {
  render() {
    const {intl, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field
          name="email"
          type="email"
          placeholder={intl.formatMessage({id: 'section.generic.email'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Button full filled loading={submitting} disabled={submitting}>
          <FormattedMessage id="section.auth.password.reset"/>
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/RecoverPasswordForm.js